
export const valor = (state = {}, action) => {

    switch (action.type) {
        case "setValor":
            return { ...state, valor: action.value }; //el action.value aveces se encuentra como action.payload            
        default:
            return state;
    }

}